import { useCookies } from "react-cookie";

export function useAuth() {
  const [cookies] = useCookies(["auth", "user"]);

  const isAuth =
    Object.keys(cookies).length === 0 ||
    (Object.keys(cookies.auth).length === 0 &&
      Object.keys(cookies.user).length === 0);

  return {
    auth: !isAuth,
    role: cookies?.user?.role,
  };
}
